import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BigWishlist, GredientArw, Location } from '../../../assests/ExportImageIcon'
import WishlistCard from './wishlistCard'

const Individual = ({ items = [], loading = false }) => {
    const navigate = useNavigate()

    if (loading) {
        return (
            <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                <p className='fare-extra-hint'>Loading your wishlists...</p>
            </div>
        )
    }

    if (!items.length) {
        return (
            <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                <div className='wishlistEmptyState'>
                    <span className='wishlistEmptyState__icon'>
                        <img src={BigWishlist} alt="" width="80" height="80" />
                    </span>
                    <div className='wishlistEmptyState__title'>No Item added in the wishlist</div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                <div className='selectItemsCount'>
                    <span className='selectItemsCount__label'>{items.length} {items.length === 1 ? 'Wishlist' : 'Wishlists'} found</span>
                </div>

                <div className='wishlistPage__list'>
                    {items.map((item) => (
                        <WishlistCard key={item.id} wishlist={item} onOpen={() => navigate(`/wishlist-detail?id=${item.id}`)} />
                    ))}
                </div>
            </div>

            <div className='mt-4'>
                <div className='wishlistItinerary'>
                    <span className='wishlistItinerary__icon'><img src={Location} alt="" /></span>
                    <div className='wishlistItinerary__text'>
                        <div className='wishlistItinerary__title'>Plan Your Perfect Itinerary</div>
                        <div className='wishlistItinerary__desc'>Organize your saved items into a complete trip itinerary with timelines, budgets, and collaborators</div>
                    </div>
                    <button type='button' className='wishlistItinerary__btn' onClick={() => navigate('/create-wishlist')}>
                        Create New Wishlist <img src={GredientArw} alt="" />
                    </button>
                </div>
            </div>
        </>
    )
}

export default Individual
